// @ts-strict-ignore
import styled from 'styled-components';
import tw from 'twin.macro';

import { Button } from '@/components/Button/Button';
import { useAWSSignIn } from '@/hooks/useAWSSignIn';
import AppleLogo from '@/logos/apple-light.svg?react';
import GoogleLogo from '@/logos/btn_google_light_normal_ios.svg?react';

const OAUTH_BUTTONS_DATA = [
  {
    provider: 'Google',
    icon: <GoogleLogo />,
    className: 'text-gray-700',
    text: 'Continue with Google',
  },
  {
    provider: 'SignInWithApple',
    icon: <AppleLogo className='h-6 w-6 fill-current text-white' />,
    className: 'bg-black text-white',
    text: 'Continue with Apple',
  },
] as const;

export const OAuthForm = ({ signup = false }: OAuthFormTypes): JSX.Element => {
  const { loginHandler } = useAWSSignIn(signup ? 'signup' : 'login');

  return (
    <AuthButtonContainer>
      {OAUTH_BUTTONS_DATA.map(({ provider, icon, text, className }, index) => (
        <Button
          key={index}
          onClick={() => loginHandler(provider)}
          startIcon={icon}
          variant='oauth'
          fullWidth
          className={className}
        >
          {text}
        </Button>
      ))}
    </AuthButtonContainer>
  );
};

type OAuthFormTypes = {
  signup: boolean;
};

const AuthButtonContainer = styled.div`
  ${tw`flex flex-col sm:flex-row gap-2 justify-between items-center`}
`;
